document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('.accordion');

  if (!accordions.length) return;

  var offset = 132;

  accordions.forEach(function(acc) {
    acc.addEventListener('toggle', function() {

      if (acc.open) {

        accordions.forEach(function(otherAcc) {
          if (otherAcc !== acc) {
            otherAcc.removeAttribute('open');
            otherAcc.classList.remove('active');
          }
        });

        acc.classList.add('active');

        setTimeout(function() {
          var top = acc.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }, 100);

      } else {
        acc.classList.remove('active');
      }

    });
  });
});